/* @flow */
// import moment from 'moment';
import 'moment/locale/pt-br';
import dateRangePickerComOpcoes from './date-range-picker-com-opcoes';

const dateRangePicker = (
    callback: Function,
    {
        dataInicial,
        dataFinal,
    }: {
        dataInicial: string,
        dataFinal: string
    },
) => {
    const opcoes = {
        id: '#m_dashboard_daterangepicker',
        dataInicial,
        dataFinal,
        callback,
    };

    dateRangePickerComOpcoes(opcoes);
};

export default dateRangePicker;
